export default "__VITE_ASSET__CsE9lL00__"